export enum StatusType {
  ERROR = 'error',
  SUCCESS = 'success',
  WAITING = 'waiting',
  WARNING = 'warning',
  IDLE = 'idle,',
}
